import { Locale } from '../model'

const getBrowserLocale = (root: Window): Locale | undefined => {
  const locale = root.navigator?.language
  if (!locale) return undefined
  return locale.substr(0, 2) as Locale
}

const getLocalStorageLocale = (root: Window, item = 'locale'): Locale | null =>
  root.localStorage.getItem(item) as Locale

const setLocalStorageLocale = (root: Window, locale: Locale, item = 'locale') =>
  root.localStorage.setItem(item, locale)

export { getBrowserLocale, getLocalStorageLocale, setLocalStorageLocale }
